import { logWarn } from '~/util/helpers/time'

class QueryService {
  /** Private methods */
  _isNoQueryName(queryName) {
    if (!queryName) {
      logWarn('QueryService get queryName is required')
      return true
    }
    return false
  }
  _isNoQueryValue(queryValue) {
    if (!queryValue) {
      logWarn('QueryService get queryValue is required')
      return true
    }
    return false
  }
  _isNoWindow() {
    if (!window) {
      logWarn('You trying access query via QueryService on the server')
      return true
    }
    return false
  }
  _getUrlParams() {
    const queryString = window?.location?.search
    return new URLSearchParams(queryString)
  }
  _setUrlParams(urlParams) {
    const baseUrl = window?.location.origin + window?.location.pathname
    const updatedUrl = urlParams.toString() ? `${baseUrl}?${urlParams.toString()}` : baseUrl
    window?.history?.replaceState(null, '', updatedUrl)
  }
  /** Exposed methods */
  get(queryName) {
    if (this._isNoWindow()) return
    if (this._isNoQueryName(queryName)) return
    return this._getUrlParams().get(queryName)
  }
  has(queryName) {
    if (this._isNoWindow()) return
    if (this._isNoQueryName(queryName)) return
    
    return this._getUrlParams().has(queryName)
  }
  remove(queryName) {
    if (this._isNoWindow()) return
    if (this._isNoQueryName(queryName)) return
    
    const urlParams = this._getUrlParams()
    urlParams.delete(queryName)
    this._setUrlParams(urlParams)
  }
  removeAll() {
    if (this._isNoWindow()) return
    
    try {
      const url = new URL(window?.location?.href)
      url.search = ''
      window?.history?.replaceState(null, '', url.toString())
    }
    catch (error) {
      logWarn('removeAll', error)
    }
  }
  set(queryName, queryValue) {
    if (this._isNoWindow()) return
    if (this._isNoQueryName(queryName)) return
    if (this._isNoQueryValue(queryValue)) return
    
    const urlParams = this._getUrlParams()
    urlParams.set(queryName, queryValue)
    this._setUrlParams(urlParams)
  }
}

export const queryService = new QueryService()
